import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-9df97204"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-root" }
const _hoisted_2 = { class: "pc-login" }
const _hoisted_3 = { class: "login-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "company_logo"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error" }, null, -1))
const _hoisted_6 = { class: "button-group" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "button-link-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-login" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBox = _resolveComponent("CheckBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("form", {
          action: "",
          class: "form",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doLogin && _ctx.doLogin(...args)), ["prevent"]))
        }, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            class: "input-text",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.uname) = $event)),
            placeholder: "请输入账户名"
          }, null, 512), [
            [_vModelText, _ctx.uname]
          ]),
          _withDirectives(_createElementVNode("input", {
            class: "input-text",
            type: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pwd) = $event)),
            placeholder: "请输入密码"
          }, null, 512), [
            [_vModelText, _ctx.pwd]
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "button",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doTrylogin && _ctx.doTrylogin(...args)), ["prevent"]))
            }, " 试 玩 "),
            _createElementVNode("button", {
              type: "submit",
              class: "submit",
              disabled: !_ctx.loginEnabled
            }, " 登 录 ", 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_CheckBox, {
              label: "记住密码",
              class: "remember-password",
              modelValue: _ctx.rememberUser,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rememberUser) = $event))
            }, null, 8, ["modelValue"])
          ])
        ], 32)
      ])
    ]),
    _hoisted_9
  ]))
}